import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("yah_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "919999999999";
export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || "contact@yourastrohub.com";
export const CONTACT_PHONE = process.env.REACT_APP_CONTACT_PHONE || "+91 99999 99999";
export const CONTACT_ADDRESS = process.env.REACT_APP_CONTACT_ADDRESS || "Delhi, India";
export const SOCIALS = {
  instagram: process.env.REACT_APP_INSTAGRAM_URL || "#",
  facebook: process.env.REACT_APP_FACEBOOK_URL || "#",
  youtube: process.env.REACT_APP_YOUTUBE_URL || "#",
};

export const waLink = (msg = "Hello, I'd like to know more about YourAstroHub.") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
